import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import './styles.scss'
import ComponentLoader from '../component-loader'
import { getComponentLabel } from '../../helper'

class SectionBox1Column extends PureComponent {
  render () {
    const sectionId = this.props.blueprint.id
    const section = this.props.factsheetBlueprint.factTree.sections[sectionId]
    const label = getComponentLabel(
      this.props.blueprint,
      section)
    return (
      <div className={'section-box-1-column'}>
        {label &&
        <div>
          <h3 className={'section-title'}>{label}</h3>
        </div>
        }
        <div>
          {this.props.blueprint.components.map((component, index) => {
            return <ComponentLoader key={index} blueprint={component}
                                    parentBlueprint={this.props.blueprint}
                                    factsheetBlueprint={this.props.factsheetBlueprint}/>
          })}
        </div>
      </div>
    )
  }
}

SectionBox1Column.propTypes = {
  blueprint: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired
}
export default SectionBox1Column
